import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import httpClient from '../../service/http.service';
import { API_SERVERLESS_ENDPOINT, AV_ENV, TEMP_URL } from '../../app.config';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';
import {
  BACKDROP_TRUE,
  BACKDROP_FALSE,
} from '../_shared/component/loaderBackDrop/loaderBackDrop.component';
import {
  useMrssSeriesList,
  useMrssMediaList,
  useMrssEpisodesList,
} from '../_shared/_function/_useReducer.hook.function';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SNACKBAR_OPEN } from '../_shared/component/snackbar/snackbar.component';
import useEvaporateService from '../_shared/_function/useEvaporate.hook.function';
import { isValidFile } from '../../utils/file';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ActionDialogComponent from '../_shared/component/actionDialog/actionDialog.component';
import {
  TableComponent,
  createCellHeader,
  createCellRows,
} from '../_shared/component/table/table.component';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import useDebounce from '../_shared/_function/useDebounce.hook.function';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  root: {},
  fabSpeedDial: {
    zIndex: 10,
    left: `calc(100% - ${theme.spacing(10)}px)`,
    position: 'fixed',
    top: `calc(100% - ${theme.spacing(10)}px)`,
  },
  fabSpeedDial2: {
    zIndex: 10,
    left: `calc(100% - ${theme.spacing(10)}px)`,
    position: 'fixed',
    top: `calc(100% - ${theme.spacing(18)}px)`,
  },
  smallButton: {
    minHeight: theme.spacing(5),
    maxHeight: theme.spacing(5),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  cardMedia: {
    height: 100,
    backgroundSize: 'contain',
    objectFit: 'contain',
  },
  cardAction: {
    justifyContent: 'center',
  },
  formControl: {
    minWidth: 120,
    '& :-webkit-autofill': {
      '-webkit-box-shadow': `0 0 0 100px ${
        theme.palette.type === 'dark' && theme.palette.primary.dark
      } inset`,
    },
  },
  tableImgContainer: {
    width: '100px',
  },
  marginLeft: {
    marginLeft: theme.spacing(1),
  },
}));

const removeByValue = (val, array, key) => {
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === val) {
      array.splice(i, 1);
      i--;
    }
  }
  return array;
};

const MrssSeriesFormComponent = () => {
  const classes = useStyles();
  const mrsslist = useMrssMediaList();
  const mrssEpisodesList = useMrssEpisodesList();
  const episodesList = mrssEpisodesList.data;

  const list = useMrssSeriesList();
  const history = useHistory();
  const dispatch = useDispatch();
  const mrssMediaList = mrsslist.data;
  const [showPromptSaveDialog, setShowPromptSaveDialog] = useState(false);

  const [editMode, setEdit] = useState(false);
  const { id } = useParams<{ id: string }>(); // URL ID PARAM
  const [mrssSeriesInfo, setMrssSeriesInfo]: any = useState({
    name: '',
    thumbnail: '',
    media: [],
    description: '',
  });
  const [originalInfo, setOriginalInfo]: any = useState();
  const [thereIsChange, setThereIsChange]: boolean | any = useState(false);
  const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
  const path = useLocation().pathname;
  const [selectedEpisodesList, setSelectedEpisodesList]: any = useState([]);
  const [searchMedia, setSearchMedia] = useState('');
  const [showMediaSelected, setShowMediaSelected] = useState(false);
  const toggleShowMediaSelectedChecked = () => {
    setShowMediaSelected((prev) => !prev);
  };
  const searchMediaDebounce = useDebounce(searchMedia, 1000);
  const [category, setCategory] = useState([]);

  const [showCategory, setShowCategory] = useState('All');

  const handleCategoryChange = (e) => {
    setShowCategory(e.target.value);
  };
  const closeSelectMediaDialog = () => {
    setMediaDialogOpen(false);
  };

  const handleSearchMediaChange = (e) => {
    setSearchMedia(e.target.value);
  };

  const [showConfirmDialog, setConfirmDialog] = useState(false);

  const closeConfirmDialog = () => {
    setConfirmDialog(false);
  };
  const openConfirmDialog = () => {
    setConfirmDialog(true);
  };

  useEffect(() => {
    let isEdit = false;
    if (path.includes('edit')) {
      isEdit = true;
      setEdit(true);
    }
    if (isEdit) {
      getMrssList();
    }
  }, []);

  useEffect(() => {
    if (mrssMediaList) {
      // unique and remove undefined
      setCategory(Array.from(new Set(mrssMediaList.flatMap((m) => m.category).filter((v) => v))));
    }
  }, [mrssMediaList]);

  const getMrssList = async () => {
    dispatch(BACKDROP_TRUE);
    try {
      let { data } = await httpClient.get(`${API_SERVERLESS_ENDPOINT}/admin/mrss-series/${id}`);
      let result: any = data.data;
      setMrssSeriesInfo({
        ...result,
      });
      setOriginalInfo({
        ...result,
      });
      dispatch(BACKDROP_FALSE);
    } catch (error) {
      console.log(error);
      dispatch(BACKDROP_FALSE);
      alert('There was an issue getting the mrss series, will be redirected back');
      history.push('/rss/mrss-series');
    }
  };

  const [updateObject, setUpdateObject] = useState({
    episodeAdd: [],
    episodeRemove: [],
  });
  const handleDataChange = (key, value) => {
    if (editMode) {
      if (value !== originalInfo[key]) {
        setThereIsChange(true);
        setUpdateObject((prev) => ({
          ...prev,
          [key]: value,
        }));
      }
    }
    setMrssSeriesInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
    if (!editMode) {
      setUpdateObject((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  // ---------- THUMBNAIL UPLOAD

  const [tempThumbnail, setTempThumbnail]: any = useState();
  const [activateBucket, setActivateBucket]: any = useState();
  const [bucketUse, setBucketUse]: any = useState('temp');
  useEvaporateService(activateBucket, bucketUse);
  const [thumbnailUploading, setThumbnailUploading]: any = useState(false);
  const handleImageUpload = (eventUploadType: any) => {
    let input: any = document.getElementById(`${eventUploadType}-input`);
    input.oninput = (e) => {
      onImageSelect(e.currentTarget, eventUploadType);
    };
    if (input) {
      input.click();
    }
  };

  const onImageSelect = (item: any, uploadType) => {
    if (item.files.length > 0) {
      const file = item.files[0];
      const isValid = isValidFile(file, 'image');
      if (isValid === false) {
        return alert('Invalid file');
      }
      setThumbnailUploading((prev) => !prev);
      let name = Date.now() + '.' + file.name.split('.')[1].toLowerCase();
      let sending = {
        contentType: file.type || 'binary/octet-stream',
        signHeaders: {},
        name: name,
        file,
        complete: () => {
          setThumbnailUploading((prev) => !prev);
          setTimeout(() => {
            setTempThumbnail(`${TEMP_URL}${name}`);
            handleDataChange('thumbnail', name);
          }, 5000);
        },
        // handleImageUploadComplete(uploadType, uploadName)
        error: () => {
          setThumbnailUploading((prev) => !prev);
          dispatch(
            SNACKBAR_OPEN({
              message: `Error uploading ${uploadType}`,
            })
          );
        },
      };
      setBucketUse('temp');
      setActivateBucket(sending);
    }
  };
  // ---------- SAVE ----------
  const handleSave = async () => {
    dispatch(BACKDROP_TRUE);
    try {
      if (editMode) {
        await httpClient.put(`${API_SERVERLESS_ENDPOINT}/admin/mrss-series/${id}`, updateObject);
      } else {
        await httpClient.post(`${API_SERVERLESS_ENDPOINT}/admin/mrss-series`, updateObject);
      }
      list.getData();
      setTimeout(() => {
        dispatch(BACKDROP_FALSE);
        if (!editMode) {
          history.push('/rss/mrss-series');
        }
      }, 1000);
      if (updateObject.episodeAdd.length > 0) {
        setMrssSeriesInfo((v) => ({
          ...v,
          episodes: [...v.episodes, ...updateObject.episodeAdd],
        }));
      }
    } catch (error) {
      console.log('...error saving MRSS series', error);
      dispatch(BACKDROP_FALSE);
    }
  };

  const handleDeleteSerie = async () => {
    setConfirmDialog(false);
    try {
      await httpClient.delete(`${API_SERVERLESS_ENDPOINT}/admin/mrss-series/${id}`);
      list.getData();
      history.push('/rss/mrss-series');
    } catch (error) {
      dispatch(
        SNACKBAR_OPEN({
          message: `Error`,
        })
      );
    }
  };

  const filterSelectedEpisode = (episode) => {
    // remove episode that is already added
    return !mrssSeriesInfo?.episodes?.includes(episode.name);
  };

  const filterSearchMedia = (media) => {
    if (searchMediaDebounce !== '') {
      return media.name.toLowerCase().includes(searchMedia.toLowerCase());
    }
    return true;
  };

  const filterMediaList = (media) => {
    if (showMediaSelected) {
      return selectedEpisodesList.includes(media._id);
    }
    return true;
  };
  return (
    <Grid container spacing={2} className={classes.root}>
      {editMode && (
        <>
          <Tooltip title='Add episodes' placement='left'>
            <Fab
              color='primary'
              aria-label='Add'
              className={classes.fabSpeedDial}
              onClick={() => setMediaDialogOpen(true)}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
          <Tooltip title='Delete serie' placement='left'>
            <Fab
              color='secondary'
              aria-label='edit'
              className={classes.fabSpeedDial2}
              onClick={openConfirmDialog}
            >
              <DeleteForeverIcon />
            </Fab>
          </Tooltip>
        </>
      )}
      <Grid item container xs={12} spacing={1}>
        <Grid item xs={12}>
          <Typography variant='h6'>
            {editMode && mrssSeriesInfo?.name
              ? `MRSS Series: ${originalInfo?.name}`
              : `Create New MRSS Series`}
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <TextField
            variant='outlined'
            size='small'
            fullWidth
            onChange={(e) => handleDataChange('name', e.target.value)}
            value={mrssSeriesInfo?.name || ''}
            label='MRSS Series Name'
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Button
            disabled={(editMode && !thereIsChange) || (!editMode && !mrssSeriesInfo.name)}
            variant='outlined'
            fullWidth
            color='primary'
            onClick={handleSave}
            className={clsx(classes.smallButton)}
          >
            {editMode ? 'Save' : 'Create'}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant='outlined'
            size='small'
            fullWidth
            onChange={(e) => handleDataChange('description', e.target.value)}
            value={mrssSeriesInfo?.description || ''}
            label='Description'
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography align='center' noWrap>
                <b>Thumbnail Image</b>
              </Typography>
              <input type='file' id='thumbnail-input' hidden />
            </CardContent>
            <div className={classes.cardMedia}>
              {(tempThumbnail || mrssSeriesInfo?.thumbnail) && (
                <CardMedia
                  component='img'
                  className={classes.cardMedia}
                  image={tempThumbnail ? tempThumbnail : `${mrssSeriesInfo?.thumbnail}`}
                  onError={(e: any) => {
                    e.persist();
                    setTimeout(() => {
                      if (tempThumbnail) {
                        e.target.src = tempThumbnail;
                      }
                    }, 5000);
                  }}
                />
              )}
            </div>
            <CardActions className={classes.cardAction}>
              <Button
                onClick={() => handleImageUpload('thumbnail')}
                className={classes.formControl}
                size='small'
                color='primary'
                variant='outlined'
              >
                {thumbnailUploading ? (
                  <CircularProgress size={22} color='primary' />
                ) : (
                  'Add Thumbnail'
                )}
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>

      {editMode && (
        <>
          <Grid item xs={12}>
            {mrssMediaList && mrssSeriesInfo.episodes?.length > 0 ? (
              <TableComponent
                colProps={[
                  {
                    width: '5%',
                  },
                  {
                    width: '10%',
                  },
                ]}
                dataSource={createCellRows({
                  dataSource: mrssSeriesInfo?.episodes.map((e) => ({ name: e })) || [],
                  cellKeys: ['name', 'removeButton'],
                  componentKey: ['removeButton'],
                  cellKeyWithProps: [
                    {
                      key: 'removeButton',
                      // props: {
                      //     colSpan: 3
                      // }
                    },
                  ],

                  classes: classes,
                  rowKey: '_id',
                  classCallBack: (e) => classes[e],
                })}
                childComponent={[
                  {
                    cellKey: 'removeButton',
                    component: (props) => {
                      return (
                        <>
                          <Button
                            variant='outlined'
                            color='secondary'
                            onClick={() => props.onClick(props.value.name)}
                          >
                            Remove
                          </Button>
                          <Button
                            className={classes.marginLeft}
                            variant='outlined'
                            color='primary'
                            onClick={() => {
                              episodesList.forEach((v) => {
                                console.log('**************** v ****************', v);
                                if (v.name === props.value.name) {
                                  props.navTo(v._id);
                                }
                              });
                            }}
                          >
                            View
                          </Button>
                        </>
                      );
                    },
                    props: {
                      // ------------------- REMOVE
                      onClick: (e) => {
                        handleDataChange('episodeRemove', [...updateObject.episodeRemove, e]);
                        let newEpisodesList = mrssSeriesInfo?.episodes
                          ? [...mrssSeriesInfo.episodes]
                          : [];
                        newEpisodesList = newEpisodesList.filter((v) => v !== e);
                        handleDataChange('episodes', newEpisodesList);
                      },
                      navTo: (e) => history.push(`/rss/mrss-episodes/edit/${e}`),
                      // color: 'primary',
                    },
                  },
                ]}
                tableHeader={createCellHeader({
                  cellKeys: ['name', 'removeButton'],
                  cellLabel: ['name', ''],
                  sortKey: ['name'],
                })}
                className={classes}
                param={{
                  rowsPerPage: 100,
                }}
              />
            ) : (
              <Typography align='center'>No Episodes</Typography>
            )}
          </Grid>
        </>
      )}

      {editMode && id && (
        <ActionDialogComponent
          message={
            <>
              <Grid container alignItems='center'>
                <Grid>
                  <TextField
                    variant='outlined'
                    margin='dense'
                    style={{ paddingRight: '20px' }}
                    onChange={handleSearchMediaChange}
                    value={searchMedia}
                    label='Search'
                  ></TextField>
                </Grid>
                <Grid>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          size='small'
                          checked={showMediaSelected}
                          color='primary'
                          onChange={toggleShowMediaSelectedChecked}
                        />
                      }
                      label='Selected'
                    />
                  </FormGroup>
                </Grid>
              </Grid>

              <TableComponent
                colProps={[
                  {
                    width: '90%',
                  },
                  {
                    width: '10%',
                  },
                ]}
                dataSource={createCellRows({
                  dataSource: episodesList
                    ?.filter(filterSelectedEpisode)
                    .filter(filterMediaList)
                    .filter(filterSearchMedia),
                  cellKeys: [
                    // "thumbnail",
                    'name',
                    'isSelected',
                  ],
                  // imageKeys: ["thumbnail"],
                  componentKey: ['isSelected'],
                  cellKeyWithProps: [
                    {
                      key: 'isSelected',
                      // props: {
                      //     colSpan: 3
                      // }
                    },
                  ],
                  classes: classes,
                  rowKey: '_id',
                  classCallBack: (e) => classes[e],
                })}
                childComponent={[
                  {
                    cellKey: 'isSelected',
                    component: (props) => {
                      let checkValue = false;
                      selectedEpisodesList.map((episode) => {
                        if (episode === props.value.name) {
                          checkValue = true;
                        }
                      });
                      return !checkValue ? (
                        <Button
                          variant='outlined'
                          color='primary'
                          onClick={() => props.onClick(props.value.name)}
                        >
                          Select
                        </Button>
                      ) : (
                        <Button
                          variant='outlined'
                          color='secondary'
                          onClick={() => props.onRemove(props.value.name)}
                        >
                          Selected
                        </Button>
                      );
                    },
                    props: {
                      // ------------------- ADD
                      onClick: (e) => {
                        setSelectedEpisodesList([...selectedEpisodesList, e]);
                      },
                      onRemove: (e) => {
                        let newList = selectedEpisodesList.filter((episode) => episode !== e);
                        setSelectedEpisodesList(newList);
                      },
                      // color: 'primary',
                    },
                  },
                ]}
                tableHeader={createCellHeader({
                  cellKeys: ['name', 'isSelected'],
                  cellLabel: ['Name', ''],
                  sortKey: ['name'],
                })}
                className={classes}
                param={{
                  rowsPerPage: 100,
                }}
              />
              <Typography>{selectedEpisodesList.length} Selected items</Typography>
            </>
          }
          title='Select Episodes'
          handleClose={closeSelectMediaDialog}
          open={mediaDialogOpen}
        >
          <Button
            disabled={selectedEpisodesList.length > 0 ? false : true}
            variant='outlined'
            color='primary'
            className={classes.smallButton}
            onClick={() => {
              // let newMediaList = mrssInfo?.media ? [...mrssInfo.media] : [];
              // let newAddedMedia: any = {
              //   ...mrssInfo?.mediaDateAdded,
              // };
              // handleMrssChange('media', newMediaList);
              handleDataChange('episodeAdd', selectedEpisodesList);
              // clear selected list
              setSelectedEpisodesList([]);
              closeSelectMediaDialog();
              // prompt dialog to save
              setShowPromptSaveDialog(true);
            }}
          >
            Add
          </Button>
          <Button
            variant='outlined'
            color='secondary'
            className={classes.smallButton}
            onClick={closeSelectMediaDialog}
          >
            Cancel
          </Button>
        </ActionDialogComponent>
      )}

      {showPromptSaveDialog && (
        <ActionDialogComponent
          message={'Save newly added media changes?'}
          open={showPromptSaveDialog}
        >
          <Button
            variant='outlined'
            color='primary'
            className={classes.smallButton}
            onClick={() => {
              handleSave();
              setShowPromptSaveDialog(false);
            }}
          >
            Save
          </Button>
          <Button
            variant='outlined'
            color='secondary'
            className={classes.smallButton}
            onClick={() => setShowPromptSaveDialog(false)}
          >
            later
          </Button>
        </ActionDialogComponent>
      )}
      <ActionDialogComponent
        message='Are you sure?'
        title='Confirmation'
        open={showConfirmDialog}
        handleClose={closeConfirmDialog}
      >
        <Button variant='outlined' onClick={handleDeleteSerie} color='primary'>
          Yes
        </Button>
        <Button variant='outlined' onClick={closeConfirmDialog} color='secondary'>
          No
        </Button>
      </ActionDialogComponent>
    </Grid>
  );
};

export default MrssSeriesFormComponent;
